<template>
  <div class="withdrawal-v2" :class="client == 'iOS' ? 'iosBox' : 'androidBox'">
    <div class="v2-header-spacer" aria-hidden="true"></div>
    <div class="v2-header-fixed">
      <div class="v2-header-inner">
        <img
          class="v2-back"
          src="../../assets/withdrawal_v2/back2.png"
          alt=""
          @click="returnBtn"
        />
        <p class="v2-title">{{ $t("withdrawalLogin.title") }}</p>
        <img
          class="v2-history"
          src="../../assets/withdrawal_v2/history.png"
          alt=""
          @click="toHistoryPage('all')"
        />
      </div>
    </div>

    <div class="v2-body" v-if="!loading">
      <div class="v2-top-body">
        <div class="v2-balance-card">
          <div class="v2-balance-top">
            <span class="v2-balance-label">{{ canWithdrawLabel }}</span>
            <img
              class="v2-tips"
              src="../../assets/withdrawal_v2/tips.png"
              alt=""
              @click.stop="openTipsDialog"
            />
          </div>
          <div class="v2-balance-amount">
            <img class="v2-coin-lg" src="../../assets/withdrawal_v2/$.png" alt="" />
            <span>{{ formatCoin(userGuildData.currentCoin) }}</span>
          </div>
        </div>

        <div class="v2-stat-row">
          <div class="v2-stat-card" @click="toPendingSettlementPage">
            <p class="v2-stat-label">{{ $t("guild_pending_settlement") }}</p>
            <div class="v2-stat-value">
              <img class="v2-coin-sm" src="../../assets/withdrawal_v2/$.png" alt="" />
              <span>{{ formatCoin(userGuildData.unsettledCoin) }}</span>
            </div>
            <img class="v2-arrow" src="../../assets/withdrawal_v2/back.png" alt="" />
          </div>
          <div class="v2-stat-card" @click="toHistoryPage('withdrawing')">
            <p class="v2-stat-label">{{ $t("guild_with_ing") }}</p>
            <div class="v2-stat-value">
              <img class="v2-coin-sm" src="../../assets/withdrawal_v2/$.png" alt="" />
              <span>{{ formatCoin(userGuildData.pendingCoin) }}</span>
            </div>
            <img class="v2-arrow" src="../../assets/withdrawal_v2/back.png" alt="" />
          </div>
        </div>
      </div>
      

      <div class="v2-list-box">
        <template v-if="1">
          <header class="v2-section-title">{{ $t("guild_funds_operation") }}</header>
          <ul class="v2-action-list">
            <li
              v-for="item in fundActions"
              :key="item.id"
              class="v2-action-item"
              @click="handleFundAction(item.id)"
            >
              <img class="v2-action-icon" :src="item.icon" alt="" />
              <span class="v2-action-text">{{ $t(item.labelKey) }}</span>
              <img class="v2-arrow" src="../../assets/withdrawal_v2/back.png" alt="" />
            </li>
          </ul>
        </template>
        <!-- <template v-if="noPermission && !loading">
          <div class="index-list">
            <WithdrawalList :parentCoin="userGuildData.currentCoin"></WithdrawalList>
          </div>
        </template> -->
      </div>
    </div>

    <van-popup
      v-model:show="show"
      closeable
      round
      position="bottom"
      :style="{ height: '20%' }"
      class="popup"
      >{{ $t("withdrawalLogin.Pocket") }}</van-popup
    >
    <!-- <div v-if="officialUrl" class="officialBox">
      <p>{{ $t("withdrawalLogin.officialGroup") }}</p>
      <p>
        <a href="#" @click.prevent.stop>{{ officialUrl }}</a>
      </p>
    </div> -->
    <div class="meta-box" v-if="loading">
          <van-loading
            type="spinner"
            color="#cccccc"
            size="20px"
          />
    </div>

    <div
      v-if="showTipsDialog"
      class="v2-tips-mask"
      @click="closeTipsDialog"
    >
      <div class="v2-tips-dialog" @click.stop>
        <span class="v2-tips-close" @click="closeTipsDialog"></span>
        <h3 class="v2-tips-title">{{ $t("guild_withdrawable_amount_title") }}</h3>
        <div class="v2-tips-content">
          <p>{{ $t("guild_withdrawable_amount_tip1") }}</p>
          <p>{{ $t("guild_withdrawable_amount_tip2", { s: userGuildData.auditHours }) }}</p>
          <p>{{ $t("guild_withdrawable_amount_tip3") }}</p>
        </div>
        <button class="v2-tips-btn" type="button" @click="closeTipsDialog">
          {{ $t("guild_got_it") }}
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { Toast,Popup,Loading } from "vant";
import WithdrawalList from "@/components/withdrawal/withdrawal-list.vue"

export default {
  name: "App",
  components: {
    WithdrawalList,
    VanPopup: Popup,
    [Loading.name]: Loading 
  },
  // 提现主页数据：客户端状态、国家列表、登录态与公会提现信息
  data() {
    return {
      client: 'PC',
      listData: {},
      token: "",
      uid: "",
      lang: "",
      show: false,
      deviceId: '',
      officialUrl:'',
      countryList:[
        {
          name:'Algeria',
          icon:require('@/assets/h5/country_a.png'),
          id:1
        },{
          name:'Belgium',
          icon:require('@/assets/h5/country_b.png'),
          id:2
        },{
          name:'Morocco',
          icon:require('@/assets/h5/country_m.png'),
          id:3
        },{
          name:'France',
          icon:require('@/assets/h5/country_f.png'),
          id:4
        }
      ],
      countryListShow:0,
      countryListIndex:0,
      loading:true,
      authFallbackTimer: null,
      showTipsDialog: false,
      // 用户公会信息
      userGuildData:{
        guildId:100997,//公会ID
        guildUid:793228,//公会长uid
        currentCoin:0,//当前P币数
        pendingCoin:0,//提现中P币数
        unsettledCoin:0,//待结算P币数
        currentUsd:0,//可提现约等于USD
        settlingCoinUsd:0,//待结算约等于USD（新接口 settlingCoinUsd）
        auditHours: 72,//风控审核最长小时数
        transferLeaderLimit: 0, //转移给会长（0 没有权限，1 有权限） 
        transferDiamondLimit: 0, //薪资转钻石（0 没有权限，1 有权限）
        transferResellerLimit: 0, //转移给reseller（0 没有权限，1 有权限）
        settlementLimit: 0, //平台结算（0 没有权限，1 有权限）
        transferToLeaderMinCoin: 0,//转移给公会长最低提现数
        // platformSettlementMinCoin: 0, //平台结算最低提现数
        appealToPlatformUrl:'',//需要跳转的url  申诉页面地址
      }
    };
  },
computed: {
  // 是否公会长视角：当前登录 uid 等于公会长 uid（newGuildInfoResult.userId 已存入 guildUid）
  isGuildLeader() {
    return String(this.uid) === String(this.userGuildData.guildUid);
  },
  // 是否无任何资金操作权限（转会长/转钻石/转reseller/平台结算全为 0 或未定义）
  noPermission() {
    return (this.userGuildData.transferLeaderLimit === 0 || this.userGuildData.transferLeaderLimit === undefined) && 
           (this.userGuildData.transferDiamondLimit === 0 || this.userGuildData.transferDiamondLimit === undefined) && 
           (this.userGuildData.transferResellerLimit === 0 || this.userGuildData.transferResellerLimit === undefined) && 
           (this.userGuildData.settlementLimit === 0 || this.userGuildData.settlementLimit === undefined);
  },
  // 用户角色/视角（埋点 user_role）：公会长 / 成员 / 其他（无法区分非成员/公会助理时归为"其他"）
  userRole() {
    if (this.isGuildLeader) return "公会长";
    if (this.noPermission) return "其他";
    return "成员";
  },
  canWithdrawLabel() {
    // 可提现约等 USD：直接使用新接口 currentCoinUsd，不再本地按汇率 15500 换算
    return this.$t("guild_can_with_usd", {
      n: this.formatCoin(this.userGuildData.currentUsd),
    });
  },
  fundActions() {
    const list = [
      {
        id: "self",
        show: true,
        icon: require("@/assets/withdrawal_v2/icon_1.png"),
        labelKey: "guild_self_withdraw",
      },
      {
        id: "platform",
        show: this.userGuildData.settlementLimit == 1,
        icon: require("@/assets/withdrawal_v2/icon_2.png"),
        labelKey: "guild_platform_settlement",
      },
      {
        id: "leader",
        // 转会长：公会长视角不显示（不能转给自己），主播需有转会长权限
        show: this.userGuildData.transferLeaderLimit == 1 && !this.isGuildLeader,
        icon: require("@/assets/withdrawal_v2/icon_3.png"),
        labelKey: "guild_transfer_to_leader",
      },
      {
        id: "reseller",
        show: this.userGuildData.transferResellerLimit == 1,
        icon: require("@/assets/withdrawal_v2/icon_4.png"),
        labelKey: "guild_salary_to_reseller",
      },
      // {
      //   id: "diamond",
      //   show: this.userGuildData.transferDiamondLimit == 1,
      //   icon: require("@/assets/withdrawal_v2/icon_3.png"),
      //   labelKey: "guild_convert_to_diamond",
      // },
    ];
    return list.filter((item) => item.show);
  },
},

  // 初始化：提取设备标识、注册原生 getUserInfo 回调、尝试用本地缓存初始化并做登录回退兜底
  created() {
    var ids = navigator.userAgent.match(
      /(iPhone|iPod|iPad|Android|BlackBerry|Windows Phone)/
    );
    if (ids) {
      ids = ids[0];
    } else {
      ids = "Unknown Device";
    }
    this.deviceId = ids;
    try {
      this.$completes.complete("getUserInfo");
      window.getUserInfo = this.getUserInfo;
      window["getUserInfo"] = (data) => {
        this.getUserInfo(data);
      };
    } catch (e) {
      this.initUserData();
    }
    // 本地已有登录态时先初始化；WebView 首次进无缓存则等 getUserInfo 回调（2026-05-08）
    this.tryInitFromCache();
    this.scheduleAuthFallback();

    // this.contact();

    this.judgeClient();
  },
  // 销毁前清除登录回退定时器
  beforeDestroy() {
    this.clearAuthFallbackTimer();
  },
  // 挂载后（页面曝光埋点在角色数据就绪后统一上报，见 initUserData）
  mounted() {},
  methods: {
    // 原生注入用户信息：保存登录态、上报登录并初始化提现数据
    getUserInfo(data) {
      this.clearAuthFallbackTimer();
      this.userInfo = JSON.parse(data);
      localStorage.setItem("data", JSON.stringify(this.userInfo));
      this.$track.login(this.userInfo);
      this.initUserData();
      this.getWhatsapp();
    },
    // 本地已有登录缓存时尝试初始化提现数据
    tryInitFromCache() {
      const raw = localStorage.getItem("data");
      if (!raw) return;
      try {
        const parsed = JSON.parse(raw);
        if (parsed && parsed.token) {
          this.initUserData();
        }
      } catch (e) {
        /* ignore */
      }
    },
    // 清除登录回退定时器，避免回调后残留
    clearAuthFallbackTimer() {
      if (this.authFallbackTimer) {
        clearTimeout(this.authFallbackTimer);
        this.authFallbackTimer = null;
      }
    },
    /** 浏览器无 getUserInfo 回调且无登录缓存时，避免 loading 一直转圈（2026-05-08） */
    scheduleAuthFallback() {
      if (this.token) return;
      this.clearAuthFallbackTimer();
      this.authFallbackTimer = setTimeout(() => {
        this.authFallbackTimer = null;
        if (!this.token && this.loading) {
          this.loading = false;
          this.$router.replace("/withdrawalLogin");
        }
      }, 2000);
    },
    // 判断平台
    judgeClient() {
      if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) { //判断iPhone|iPad|iPod|iOS
        this.client = 'iOS';
      } else if (/(Android)/i.test(navigator.userAgent)) { //判断Android
        this.client = 'Android';
      } else {
        this.client = 'PC';
      }
      return this.client;
    },
    // 展示国家列表
    changeCountryList(index=0){
      this.countryListShow = !this.countryListShow;
      this.countryListIndex = index;
    },  
    // 金额千分位格式化
    formatCoin(val) {
      return Number(val || 0).toLocaleString("en-US");
    },
    // 打开可提现说明弹窗
    openTipsDialog() {
      this.showTipsDialog = true;
    },
    // 关闭可提现说明弹窗
    closeTipsDialog() {
      this.showTipsDialog = false;
    },
    // 跳转待结算列表页，携带审核最长小时数与公会信息（供后续跳转提现记录使用）
    toPendingSettlementPage() {
      this.$router.push({
        path: "/pending-settlement",
        query: {
          auditHours: this.userGuildData.auditHours || 72,
          guildId: this.userGuildData.guildId,
          guildUid: this.userGuildData.guildUid,
          toUrl: this.userGuildData.appealToPlatformUrl,
        },
      });
    },
    // 跳转提现历史页，携带公会 id / 公会长 uid / 申诉链接，并默认筛选"提现中"
    toHistoryPage(type) {
      this.$router.push({
        path: "/withdrawal-history",
        query: {
          guildId: this.userGuildData.guildId,
          guildUid: this.userGuildData.guildUid,
          toUrl: this.userGuildData.appealToPlatformUrl,
          filter: type,
        },
      });
    },
    // 资金操作入口：按类型跳转到对应业务页（自提现/平台结算/转会长/转reseller）
    handleFundAction(id) {
      const d = this.userGuildData;
      switch (id) {
        case "self":
          // 自提现：传入可提现余额
          this.$router.push({
            path: "/self-withdrawal",
            query: { cin: d.currentCoin.toLocaleString("en-US") },
          });
          break;
        case "platform":
          // 平台结算：传入申诉链接
          this.$router.push({
            path: "/to-platform",
            query: { toUrl: d.appealToPlatformUrl },
          });
          break;
        case "leader":
          // 转移给公会长：传入余额/公会信息/最低金额/申诉链接
          this.$router.push({
            path: "/to-guild-leader",
            query: {
              cin: d.currentCoin,
              guildId: d.guildId,
              guildUid: d.guildUid,
              minCoin: d.transferToLeaderMinCoin,
              toUrl: d.appealToPlatformUrl,
              leaderAvatar: d.leaderAvatar
            },
          });
          break;
        case "reseller":
          // 转移给 reseller：传入余额/公会信息/最低金额
          this.$router.push({
            path: "/to-reseller",
            query: {
              cin: d.currentCoin.toLocaleString("en-US"),
              guildId: d.guildId,
              guildUid: d.guildUid,
              minCoin: d.transferToLeaderMinCoin,
            },
          });
          break;
        case "diamond":
          this.$router.push({ path: "/to-diamond" });
          break;
      }
    },
    // 返回按钮：type=1（来自原生登录）时关闭 webview，否则回登录页
    returnBtn() {
      if(this.$route.query.type == 1){
        this.$completes.complete("getPreviousPage");
      }else{
        this.$router.push("/withdrawalLogin");
      }
    },

    // 拉取渠道列表数据并排序（旧版渠道展示，当前入口已改用 WithdrawalList）
    contact() {
      axios
        .get(this.$serviceIp +`/api/trade/card/tx/getInfoForWeb?token=${this.token}&uid=${this.uid}`,{
            headers: {
                'deviceId': this.deviceId,
                'lang': this.lang,
              }
        })
        .then((response) => {
          if (response.data.code == 200) {
            this.listData = response.data.data;
            this.sortList(this.listData.item);
          } else {
            Toast(response.data.message || this.$t("transfer.error"));
          }
        }).catch(()=>{

        }).finally(()=>{
          this.loading = false
        });
    },
    // 初始化用户信息：先初始化登录态与语言，再拉取公会提现数据
    initUserData() {
      // 无有效登录缓存则回登录页
      if (!this.initUserLangInfo()) {
        this.loading = false;
        this.clearAuthFallbackTimer();
        this.$router.replace("/withdrawalLogin");
        return;
      }
      this.clearAuthFallbackTimer();
      axios
        .get(this.$serviceIp +`api/trade/guild/withdraw/init?token=${this.token}&uid=${this.uid}`,{
            headers: {
                'deviceId': this.deviceId,
                'version': '3.0',
                'lang': this.lang,
              }
        })
        .then(({data}) => {
          if (data.code == 200) {
            let newGuildInfoResult = data.data.newGuildInfoResult || {};
            // 可提现 P 币（新接口 currentCoin：available/10000 后的最终展示值，直接使用）
            this.userGuildData.currentCoin = data.data.currentCoin || 0
            // 提现中 P 币（不变）
            this.userGuildData.pendingCoin = data.data.pendingCoin || 0
            // 待结算 P 币（新接口 settlingCoin：settling/10000 后的最终展示值）
            this.userGuildData.unsettledCoin = data.data.settlingCoin || 0
            // 可提现约等 USD（新接口 currentCoinUsd）
            this.userGuildData.currentUsd = data.data.currentCoinUsd || 0
            // 待结算约等 USD（新接口 settlingCoinUsd）
            this.userGuildData.settlingCoinUsd = data.data.settlingCoinUsd || 0
            // 风控审核最长小时数（新接口 reviewHours：N/60，直接使用）
            this.userGuildData.auditHours = data.data.reviewHours || 72
            // 公会 ID 与公会长 uid
            this.userGuildData.guildId = newGuildInfoResult.id
            this.userGuildData.guildUid = newGuildInfoResult.userId
            // 各类资金操作权限标记（0 无权限，1 有权限）
            this.userGuildData.transferLeaderLimit = newGuildInfoResult.transferLeaderLimit
            this.userGuildData.transferDiamondLimit = newGuildInfoResult.transferDiamondLimit
            this.userGuildData.transferResellerLimit = newGuildInfoResult.transferResellerLimit
            this.userGuildData.settlementLimit = newGuildInfoResult.settlementLimit
            // 转移给公会长最低提现数（依赖路由 minCoin，接口未返回时此处为 undefined 不影响）
            this.userGuildData.transferToLeaderMinCoin = data.data.transferToLeaderMinCoin
            // this.userGuildData.platformSettlementMinCoin = data.data.platformSettlementMinCoin
            this.userGuildData.appealToPlatformUrl = data.data.appealToPlatformUrl
            // 公会长头像
            this.userGuildData.leaderAvatar = data.data.leaderAvatar
            // 页面曝光埋点（角色数据就绪后上报，带 user_role）
            this.$track.trackPageView(this.$track.PAGE_NAME.WITHDRAW, {
              page_id: "withdraw_page",
              page_name: "提现页面",
              user_role: this.userRole,
            });
          } else {
            Toast(data.message || this.$t("transfer.error"));
          }
        }).catch(()=>{}).finally(()=>{
          this.loading = false
        });
    },
    // 初始化登录态与语言：从本地缓存读取用户信息，设置 i18n locale 与请求头参数
    initUserLangInfo() {
      const raw = localStorage.getItem("data");
      if (!raw) return false;
      let data;
      try {
        data = JSON.parse(raw);
      } catch (e) {
        return false;
      }
      if (!data || !data.token) return false;
      this.token = data.token;
      this.uid = data.uid || data.userId;
      this.lang = data.lang || navigator.language;
      this.deviceId = data.deviceId || this.deviceId;
      let langs = this.lang.substring(0, 2);
      if (langs == "zh") {
        if (this.lang == "zh-TW" || this.lang == "zh-HK") {
          this.$i18n.locale = "tc";
        } else {
          this.$i18n.locale = "zh";
        }
      } else if (langs == "en") {
        this.$i18n.locale = "en";
      } else if (langs == "ar") {
        this.$i18n.locale = "ar";
      } else if (langs == "tr") {
        this.$i18n.locale = "tr";
      } else if (langs == "es") {
        this.$i18n.locale = "es";
      } else if (langs == "pt") {
        this.$i18n.locale = "pt";
      } else if (langs == "fr") {
        this.$i18n.locale = "fr"
      } else if (langs == "id") {
        this.$i18n.locale = "id"
      } else if (langs == "ms") {
        this.$i18n.locale = "ms"
      } else {
        this.$i18n.locale = "en";
      }
      document.title = this.$t("withdrawalLogin.title");
      document.querySelector("html").setAttribute("lang", this.$i18n.locale);
      if (data.uid) {
        this.changeTime();
      }
      return true;
    },
    // 获取官方群
    getWhatsapp() {
      axios
        .get(this.$serviceIp +`/api/trade/withdraw/whatsappForWeb?token=${this.token}&uid=${this.uid}`,{
            headers: {
                'version': '3.0',
                'deviceId': this.deviceId,
                'lang': this.lang,
              }
        })
        .then((response) => {
          if (response.data.code == 200) {
              this.officialUrl = response.data.data;
          }
        });
    },
    // 排序
    sortList(item){
      item.forEach(element => {
        element.list.sort((a, b) => {
          return a.sort - b.sort;
        });
      });
    },
    // 旧版标准渠道提现：余额不足提示，否则初始化后跳转 withdrawalDetails（已由新流程替代）
    channelBtn(item, Aitem) {
      if (this.listData.cin < Aitem.usd) {
        this.show = true;
        return;
      }
      axios
        .get(
          this.$serviceIp +
            `api/trade/card/tx/initForWeb?token=${this.token}&uid=${this.uid}&id=${item.id}`,{
              headers: {
                'deviceId': this.deviceId,
                'lang': this.lang,
              }
            }
        )
        .then((response) => {
          if (response.data.code == 200) {
            this.$router.push({
              path: "/withdrawalDetails",
              query: {
                obj: JSON.stringify(response.data.data.infos),
                newobj: JSON.stringify(Aitem),
                id:item.id,
                sabankList: JSON.stringify(response.data.data.sabankList) || ''
              },
            });
          } else {
            Toast(response.data.message || this.$t("transfer.error"));
          }
        });
    },

    // 旧版 PIX 渠道提现：余额不足提示，否则初始化后跳转 pixDetails（已由新流程替代）
    channelPixBtn(item, Aitem) {
      if (this.listData.cin < Aitem.usd) {
        this.show = true;
        return;
      }
      axios
        .get(
          this.$serviceIp +
            `/api/trade/card/tx/initForWeb?token=${this.token}&uid=${this.uid}&id=${item.id}`,{
              headers: {
                'deviceId': this.deviceId,
                'lang': this.lang,
              }
            }
        )
        .then((response) => {
          if (response.data.code == 200) {
            this.$router.push({
              path: "/pixDetails",
              query: {
                obj: JSON.stringify(response.data.data.infos),
                newobj: JSON.stringify(Aitem),
              },
            });
          } else {
            Toast(response.data.message || this.$t("transfer.error"));
          }
        });
    },

    // 登录过期检测：time 早于当前时间则清理缓存并跳转登录页
    changeTime() {
      let item = JSON.parse(localStorage.getItem("time"));
      if (item < Date.now()) {
        localStorage.removeItem("data");
        localStorage.removeItem("time");
        this.$router.push("/withdrawalLogin");
      }
    },
  },
};
</script>
<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.withdrawal-v2 {
  min-height: 100vh;
  background: #f5f6f8;
  font-family: "Montserrat", sans-serif;
  display: flex;
  flex-direction: column;
}

.iosBox {
  /* 安全区由 v2-header-fixed 处理 */
}

.v2-header-spacer {
  height: calc(88px + env(safe-area-inset-top));
  height: calc(88px + constant(safe-area-inset-top));
  flex-shrink: 0;
}

.v2-header-fixed {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  padding-top: env(safe-area-inset-top);
  padding-top: constant(safe-area-inset-top);
  background: #f5f6f8;
}

.v2-header-inner {
  position: relative;
  height: 88px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 28px;
}

.v2-back {
  position: absolute;
  left: 28px;
  top: 50%;
  transform: translateY(-50%);
  width: 64px;
  height: 64px;
}

.v2-title {
  margin: 0;
  padding: 0;
  font-size: 26px;
  font-weight: 600;
  color: #121212;
  text-align: center;
}

.v2-history {
  position: absolute;
  right: 28px;
  top: 50%;
  transform: translateY(-50%);
  width: 64px;
  height: 64px;
}

.v2-body {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  margin-top: 12px;
}
.v2-top-body{
  padding: 0 28px; 
}
.v2-balance-card {
  width: 100%;
  min-height: 180px;
  padding: 40px;
  border-radius: 24px;
  background: url("../../assets/withdrawal_v2/head_bg.png") no-repeat center;
  background-size: 100% 100%;
  color: #fff;
}

.v2-balance-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.v2-balance-label {
  font-size: 20px;
  font-weight: 400;
  color: #FFFFFF;
}

.v2-tips {
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  cursor: pointer;
}

.v2-tips-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 300;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 48px;
}

.v2-tips-dialog {
  position: relative;
  width: 100%;
  max-width: 592px;
  background: #fff;
  border-radius: 24px;
  padding: 60px 32px 32px;
}

.v2-tips-close {
  position: absolute;
  top: 24px;
  right: 24px;
  width: 28px;
  height: 28px;
  cursor: pointer;
  background: url('../../assets/withdrawal_v2/close.png') no-repeat;
  background-size: 100% 100%;
}

.v2-tips-title {
  margin: 0 0 24px;
  font-size: 28px;
  font-weight: 500;
  line-height: 1.2;
  color: #1F1315;
  text-align: center;
}

.v2-tips-content {
  font-size: 24px;
  line-height: 36px;
  font-weight: 400;
  color: #504C54;
}

.v2-tips-content p {
  margin: 0 0 24px;
}

.v2-tips-content p:last-child {
  margin-bottom: 0;
}

.v2-tips-btn {
  display: block;
  width: 412px;
  height: 80px;
  margin: 32px auto 0;
  border: none;
  border-radius: 40px;
  background: #8131E7;
  font-size: 24px;
  font-weight: 500;
  color: #fff;
}

html[lang="ar"] .v2-tips-close {
  right: auto;
  left: 24px;
}

html[lang="ar"] .v2-tips-content {
  text-align: right;
}

.v2-balance-amount {
  display: flex;
  align-items: center;
  margin-top: 16px;
}

.v2-coin-lg {
  width: 52px;
  height: 52px;
  margin-right: 8px;
  flex-shrink: 0;
}

.v2-balance-amount span {
  font-size: 48px;
  font-weight: 700;
  line-height: 1;
  letter-spacing: -0.5px;
}

.v2-stat-row {
  display: flex;
  gap: 16px;
  margin-top: 24px;
}

.v2-stat-card {
  flex: 1;
  min-width: 0;
  background: #fff;
  border-radius: 20px;
  padding: 24px;
  position: relative;
  .v2-arrow{
    position: absolute;
    top: 50%;
    transform: translateY(-50%) scaleX(-1);
    right: 16px;
  }
}

.v2-stat-label {
  font-size: 20px;
  color: #89848d;
  font-weight: 500;
  margin-bottom: 8px;
}

.v2-stat-value {
  display: flex;
  align-items: center;
  min-height: 40px;
}

.v2-coin-sm {
  width: 32px;
  height: 32px;
  margin-right: 4px;
  flex-shrink: 0;
}

.v2-stat-value span {
  flex: 1;
  min-width: 0;
  font-size: 28px;
  font-weight: 700;
  color: #0F172A;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* 待结算约等 USD 展示：小号次要颜色，不参与主轴 flex 占位 */
.v2-stat-usd {
  flex: none !important;
  margin-left: 6px;
  font-size: 16px !important;
  font-weight: 400 !important;
  color: #8A94A6 !important;
  white-space: nowrap;
}

.v2-arrow {
  flex-shrink: 0;
  width: 28px;
  height: 28px;
  margin-left: 8px;
  transform: scaleX(-1);
}

.v2-list-box {
  flex: 1;
  margin-top: 24px;
  background: #fff;
  border-radius: 24px 24px 0 0;
  padding: 24px 32px calc(24px + env(safe-area-inset-bottom));
  padding-bottom: calc(24px + constant(safe-area-inset-bottom));
}

.v2-section-title {
  font-size: 24px;
  font-weight: 500;
  color: #AFA9B4;
  margin-bottom: 24px;
}

.v2-action-list {
  list-style: none;
}

.v2-action-item {
  display: flex;
  align-items: center;
  padding-bottom: 34px;
  border-bottom: 1px solid #f1f1f1;
  margin-bottom: 34px;
}

.v2-action-item:last-child {
  border-bottom: none;
}

.v2-action-icon {
  width: 32px;
  height: 32px;
  margin-right: 16px;
  flex-shrink: 0;
}

.v2-action-text {
  flex: 1;
  font-size: 24px;
  font-weight: 500;
  color: #121212;
}

html[lang="ar"] .withdrawal-v2 {
  direction: rtl;
}

html[lang="ar"] .v2-back {
  left: auto;
  right: 28px;
  transform: translateY(-50%) rotateY(180deg);
}

html[lang="ar"] .v2-history {
  right: auto;
  left: 28px;
}

html[lang="ar"] .v2-coin-lg,
html[lang="ar"] .v2-coin-sm {
  margin-right: 0;
  margin-left: 8px;
}

html[lang="ar"] .v2-action-icon {
  margin-right: 0;
  margin-left: 16px;
}

html[lang="ar"] .v2-stat-card .v2-arrow {
  transform: translateY(-50%) scaleX(1);
}

html[lang="ar"] .v2-action-item .v2-arrow {
  transform: scaleX(1);
  margin-left: 0;
  margin-right: 8px;
}
html[lang="ar"] .v2-stat-card .v2-arrow {
  right: auto;
  left: 16px;
}
.popup {
  font-size: 24px;
  color: #000;
  font-weight: 500;
  display: flex;
  justify-content: center;
  align-items: center;
}

.meta-box {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 200;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.4);
}
</style>
<style>
.index-list .list-box {
  background: #F6F7F9;
}
</style>